import safeGetPathname from './safeGetPathname';

export default (singleLicenseFlowFF, remediationUrl) => {
  const { pathname } = window.location;
  if (singleLicenseFlowFF) {
    return !pathname.startsWith('/access');
  }
  return !pathname.startsWith(safeGetPathname(remediationUrl));
};
